// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.vrmodel.RentalManagerUserPropertyVrModelWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyVrModelWebApiHandler_associateListing,
  RentalManagerUserPropertyVrModelWebApiHandler_associateModel,
  RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels,
  RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_Path,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  ListingAlias,
  UserPropertyVrModelAssociateListingResponseWebDto,
  UserPropertyVrModelAssociateModelResponseWebDto,
  UserPropertyVrModelGetAllVrModelsResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface AssociateListingParams {
  listingAlias: ListingAlias;
  shouldAssociate: boolean;
  vrModelId: number;
}
interface AssociateModelParams {
  encodedFloorplanKey: string;
  listingAlias: ListingAlias;
  shouldAssociate: boolean;
  vrModelId: number;
}
interface GetAllVrModelsParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertyVrModelWebApiHandler_associateListing_Args {
  getParams: AssociateListingParams;
}

export type RentalManagerUserPropertyVrModelWebApiHandler_associateListing_Options = UseMutationOptions<
  UserPropertyVrModelAssociateListingResponseWebDto,
  unknown,
  RentalManagerUserPropertyVrModelWebApiHandler_associateListing_Args
>;

/**
 * Associate / Disassociate a vrModel to listing
 */
export const useRentalManagerUserPropertyVrModelWebApiHandler_associateListing = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyVrModelWebApiHandler_associateListing_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyVrModelWebApiHandler_associateListing_Args) =>
      RentalManagerUserPropertyVrModelWebApiHandler_associateListing(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyVrModelWebApiHandler_associateModel_Args {
  getParams: AssociateModelParams;
}

export type RentalManagerUserPropertyVrModelWebApiHandler_associateModel_Options = UseMutationOptions<
  UserPropertyVrModelAssociateModelResponseWebDto,
  unknown,
  RentalManagerUserPropertyVrModelWebApiHandler_associateModel_Args
>;

/**
 * Associate / Disassociate a vrModel to a floor plan or unit
 */
export const useRentalManagerUserPropertyVrModelWebApiHandler_associateModel = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyVrModelWebApiHandler_associateModel_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyVrModelWebApiHandler_associateModel_Args) =>
      RentalManagerUserPropertyVrModelWebApiHandler_associateModel(args.getParams, httpClient),
  });
};

export type RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_Options = UseQueryOptions<
  UserPropertyVrModelGetAllVrModelsResponseWebDto,
  unknown,
  UserPropertyVrModelGetAllVrModelsResponseWebDto,
  readonly [string, GetAllVrModelsParams]
>;

const RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_GetKey = (getParams: GetAllVrModelsParams) =>
  [RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_Path, getParams] as const;

export const RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_queryOptions = (
  getParams: GetAllVrModelsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Retrieve all vr models
 */
export const useRentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels = (
  getParams: GetAllVrModelsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels.getKey =
  RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_GetKey;
